{
  "AGENT_BOTS": {
    "HEADER": "الروبوتات",
    "LOADING_EDITOR": "جار جلب المحرر...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "النظام",
    "AVATAR": {
      "SUCCESS_DELETE": "تم حذف الصورة الرمزية للروبوت بنجاح",
      "ERROR_DELETE": "حدث خطأ أثناء حذف الصورة الرمزية للروبوت، يرجى المحاولة مرة أخرى"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "اسم الروبوت",
        "PLACEHOLDER": "قم بتسمية الروبوت الخاص بك.",
        "ERROR": "اسم الروبوت مطلوب."
      },
      "DESCRIPTION": {
        "LABEL": "وصف الروبوت",
        "PLACEHOLDER": "ماذا يفعل هذا الروبوت؟"
      },
      "BOT_CONFIG": {
        "ERROR": "يرجى إدخال تكوين نبوت CSML الخاص بك أعلاه.",
        "API_ERROR": "تكوين CSML الخاص بك غير صالح. يرجى إصلاحه والمحاولة مرة أخرى."
      },
      "SUBMIT": "التحقق والحفظ"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "اختر الروبوت",
      "DESC": "قم بتعيين روبوت لصندوق الوارد الخاص بك. يمكنهم التعامل مع المحادثات الأولية ونقلها إلى وكيل مباشر عند الضرورة.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "تحديث",
      "DISCONNECT": "قطع اتصال الروبوت",
      "SUCCESS_MESSAGE": "تم تحديث الروبوت بنجاح.",
      "DISCONNECTED_SUCCESS_MESSAGE": "تم فصل الروبوت بنجاح.",
      "ERROR_MESSAGE": "تعذر تحديث الروبوت. يرجى المحاولة مرة أخرى.",
      "DISCONNECTED_ERROR_MESSAGE": "تعذر فصل الروبوت. يرجى المحاولة مرة أخرى.",
      "SELECT_PLACEHOLDER": "اختر الروبوت",
      "COUNTRY_BOTS": {
        "TITLE": "الروبوتات حسب البلد",
        "DESC": "يخدم صندوق الوارد هذا عدة بلدان. تنتقل المحادثة إلى روبوت بلدها: حسب متجر Kaufland، أو سوق طلب Allegro، وإلا فبحسب اللغة التي يكتب بها العميل. تنتقل بقية المحادثات إلى الروبوت الافتراضي أعلاه.",
        "COUNTRY": "اختر بلداً",
        "BOT": "اختر الروبوت",
        "ADD": "إضافة روبوت لبلد",
        "REMOVE": "إزالة",
        "DEFAULT_REQUIRED": "اختر الروبوت الافتراضي أولاً. لا يحل روبوت البلد محله إلا في ذلك البلد.",
        "DISCONNECT_ALL": "قطع اتصال جميع الروبوتات"
      }
    },
    "ADD": {
      "TITLE": "تكوين روبوت جديد",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "API": {
        "SUCCESS_MESSAGE": "تمت إضافة الروبوت بنجاح.",
        "ERROR_MESSAGE": "تعذر إضافة الروبوت. يرجى المحاولة مرة أخرى لاحقًا."
      }
    },
    "LIST": {
      "404": "لم يتم العثور على أي روبوتات. يمكنك إنشاء الروبوت بالنقر على زر 'تكوين روبوت جديد' ↗",
      "LOADING": "جار جلب الروبوتات...",
      "TABLE_HEADER": {
        "DETAILS": "تفاصيل الروبوت",
        "URL": "رابط Webhook"
      },
      "TYPE": "نوع الروبوت"
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "TITLE": "حذف الروبوت",
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد أنك تريد حذف {name}؟",
        "YES": "نعم، احذف",
        "NO": "لا، احتفظ به"
      },
      "SUBMIT": "حذف",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذا الروبوت؟ هذا الإجراء لا يمكن التراجع عنه.",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف الروبوت بنجاح.",
        "ERROR_MESSAGE": "تعذر حذف الروبوت. يرجى المحاولة مرة أخرى."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "تعديل",
      "LOADING": "جار جلب الروبوتات...",
      "TITLE": "تعديل الروبوت",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث الروبوت بنجاح.",
        "ERROR_MESSAGE": "تعذر تحديث الروبوت. يرجى المحاولة مرة أخرى."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "الصورة الرمزية للروبوت"
      },
      "NAME": {
        "LABEL": "اسم الروبوت",
        "PLACEHOLDER": "أدخل اسم الروبوت"
      },
      "DESCRIPTION": {
        "LABEL": "الوصف",
        "PLACEHOLDER": "ما الذي يقوم به هذا الروبوت؟"
      },
      "WEBHOOK_URL": {
        "LABEL": "رابط Webhook",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "اسم الروبوت مطلوب",
        "URL": "رابط Webhook مطلوب",
        "VALID_URL": "يرجى إدخال رابط صالح يبدأ بـ http:// أو https://"
      },
      "CANCEL": "إلغاء",
      "CREATE": "إنشاء روبوت",
      "UPDATE": "تحديث الروبوت"
    },
    "TYPES": {
      "WEBHOOK": "روبوت الـWebhook",
      "CSML": "بوت CSML"
    }
  }
}
